module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic-container"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "scroller"
    }
  }, [_c('div', {
    staticClass: "ui-refresh-down",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_PullDown"
    }
  }, [_c('span', {
    staticClass: "refresh-down-label"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "topic-info",
    attrs: {
      "id": "thelist",
      "data-curPage": "",
      "data-maxPage": ""
    }
  }, [_c('img', {
    staticClass: "loading-img",
    attrs: {
      "src": require("../assets/loading.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui-refresh-up",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_PullUp"
    }
  }, [_c('span', {
    staticClass: "refresh-up-label"
  }, [_vm._v("加载更多")]), _c('img', {
    staticClass: "pull-up-img",
    attrs: {
      "src": require("../assets/loading.gif")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b4a9c0c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topic.vue
// module id = 202
// module chunks = 1